
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SymmetricOrbsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const count = Math.floor(12 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const angle = (i / count) * Math.PI * 2 + curTime * 0.2;
                const r = (100 + i * 40 + Math.sin(curTime + i) * 50) * scale * (1 / (layerIndex + 1));
                const size = (10 + Math.cos(curTime * 0.5 + i) * 5) * scale;
                
                const px = Math.cos(angle) * r;
                const py = Math.sin(angle) * r;
                
                ctx.beginPath();
                ctx.arc(px, py, size, 0, Math.PI * 2);
                ctx.fill();
                
                // Mirror orb
                ctx.beginPath();
                ctx.arc(-px, -py, size, 0, Math.PI * 2);
                ctx.fill();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
